export default __webpack_public_path__ + "static/media/network.42a5dd5e.png";